import React from "react";
import { CacheProvider } from "@emotion/react";
import { ThemeProvider } from "@mui/material/styles";
import { AuthProvider } from "../context/AuthContext";
import theme from "../theme";
import { PublicPageData } from "./PublicPageData";

export default function AppProviders({ children, cache, data = {}, initialAnonymous = false }) {
  return (
    <CacheProvider value={cache}>
      <ThemeProvider theme={theme}>
        <PublicPageData.Provider value={data}>
          <AuthProvider initialAnonymous={initialAnonymous}>{children}</AuthProvider>
        </PublicPageData.Provider>
      </ThemeProvider>
    </CacheProvider>
  );
}
